// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__RvhFQ","alert":"SettungsInbox_alert__Os7lB"};